import dayjs from 'dayjs';
import React, { useState } from 'react'
import { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import { Form, Schema, SelectPicker } from 'rsuite';
import credentialService from '../../../../services/Internal/Credential/credential.service';
import { getCredStatus, getCredStatusReason } from '../../../../services/Shared/codeTable.service';
import RedStar from '../../../Shared/GenericComponents/RedStar';

function LegacyWgCredentialForm(props) {
    const [formData, setFormData] = useState({
        entityId: props.entityId,
        status: "",
        statusReason: "",
        firstIssuanceDate: null,
        effectiveDate: null,
        expirationDate: null,
        applicationDate: null,
        applicationType: "Waiver Granted",
        reinstatementDate: null,
        approvedBy: "",
        userMod: "",
        dateMod: null
    });
    const [credStatus, setCredStatus] = useState([])
    const [credReason, setCredReason] = useState([])
    useEffect(() => {
        getCredStatus().then((credentialStatuses) => {
            // 6 = Disapproved
            // 7 = Do Not Issue License
            // 8 = Pending
            // 9 = Lapsed Application
            var wgOnlyStatuses = credentialStatuses.filter((credentialStatus) => [6, 7, 8, 9].includes(credentialStatus?.value?.id));
            setCredStatus(wgOnlyStatuses);
        });
    }, [])

    const { ObjectType, DateType } = Schema.Types;
    const model = Schema.Model({
        statusReason: ObjectType().isRequired('This field is required.'),
        status: ObjectType().isRequired('This field is required.'),
        applicationDate: DateType('Please enter a valid date.').isRequired('This field is required')
    })

    const handleCredentialStatusChange = (val) => {
        setFormData({ ...formData, status: val, statusReason: null })
        getCredStatusReason(val?.id, val?.status).then((credStatusReasons) => {
            if (val?.id == 8) {
                var pendingStatuses = credStatusReasons.filter((credReason) => [25].includes(credReason?.value?.id))
                setCredReason(pendingStatuses);
            }
            else
            {
                setCredReason(credStatusReasons);
            }
        });
    }

    const submitForm = (validation, event) => {
        if (validation) {
            var dataToTransmit = {
                ...formData
            }
            credentialService.createLegacyWgCredential(dataToTransmit).then((response) => {
                props.saveSuccess(response.data);
            });
        }
    }

    return (
        <Form id={props.formId} fluid model={model} formValue={formData} onChange={setFormData} onSubmit={submitForm} >
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Application Type</b></Form.ControlLabel>
                    <Form.Control name="applicationType" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Status</b> <RedStar /></Form.ControlLabel>
                        <Form.Control
                            name="status"
                            block
                            data={credStatus}
                            accepter={SelectPicker}
                            searchable={false}
                            placeholder="Select Status"
                            onChange={handleCredentialStatusChange} />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Reason</b> <RedStar /></Form.ControlLabel>
                    <Form.Control
                        name="statusReason"
                        block
                        data={credReason}
                        accepter={SelectPicker}
                        searchable={false}
                        readOnly={!formData.status}
                        placeholder="Select Status Reason" />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Application Date</b> <RedStar /></Form.ControlLabel>
                    <Form.Control name="applicationDate" type="date" />
                </Col>
                <Col>
                    <Form.ControlLabel><b>First Issuance Date</b></Form.ControlLabel>
                    <Form.Control name="firstIssuanceDate" type="date" />
                </Col>

                <Col>
                    <Form.ControlLabel><b>Effective Date</b></Form.ControlLabel>
                    <Form.Control name="effectiveDate" type="date" />
                </Col>

            </Row>
        </Form>
    );
}

export default LegacyWgCredentialForm;